module.exports = __webpack_public_path__ + "img/donation.174cce55.png";